import { updateTopCoverAnisotropy } from "../../../helpers/updateTopCoverAnisotropy";

export default [
    {
        key: "kryshka_tumbi",
        allArray: "allKrishkaTumbi",
        activeArray: "activeKrishkaTumbi",
        position: "bottom",
        extra: (el) => updateTopCoverAnisotropy(el),
    },
];
